import { AppCheck, getToken, onTokenChanged } from 'firebase/app-check';

let appCheck: AppCheck | undefined;

/** La registra main.ts en cuanto App Check queda inicializado. */
export function registerAppCheck(instance: AppCheck): void {
  appCheck = instance;

  // Traza de desarrollo: onTokenChanged salta cada vez que el SDK obtiene y
  // cachea un token nuevo (al arrancar y en cada renovación), que es justo el
  // momento en que se guarda en IndexedDB. Solo en la máquina del dev: el
  // token es una credencial y no debe acabar en la consola de ningún entorno
  // desplegado, dev incluido. Se mira el host y no environment.production
  // porque environment.dev.ts también lo tiene a false.
  if (esLocalhost()) {
    onTokenChanged(instance, (result) => {
      console.log('[App Check] token guardado', {
        expira: expiracionDe(result.token),
        token: result.token,
      });
    });
  }
}

function esLocalhost(): boolean {
  const host = globalThis.location?.hostname ?? '';
  return host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
}

/** Lee el `exp` del JWT para saber hasta cuando vale el token. */
function expiracionDe(token: string): string {
  try {
    const payload = JSON.parse(atob(token.split('.')[1])) as { exp?: number };
    return payload.exp ? new Date(payload.exp * 1000).toLocaleString() : '?';
  } catch {
    return '?';
  }
}

/**
 * Token para la cabecera X-Firebase-AppCheck, o null si todavía no hay App
 * Check: la site key del entorno está vacía, o la inicialización aún no ha
 * ocurrido (arranca después del bootstrap de Angular, ver main.ts).
 *
 * getToken() devuelve el token cacheado sin salir a red mientras siga vigente
 * (TTL de 1h), así que llamarlo en cada petición no añade latencia salvo la
 * primera vez.
 */
export async function getAppCheckToken(): Promise<string | null> {
  if (!appCheck) {
    return null;
  }

  try {
    const { token } = await getToken(appCheck, false);
    return token;
  } catch (error) {
    // Un fallo de App Check no puede tumbar la petición: que sea el backend
    // quien decida si acepta una llamada sin cabecera.
    console.warn('No se pudo obtener el token de App Check:', error);
    return null;
  }
}
